
import React, { useState, useRef } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Popover,
    Button,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme, styled} from '@mui/material/styles';
import {FilterModel} from '../../models/modelsFilter';
import { DateField } from "@mui/x-date-pickers/DateField";
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { MonthCalendar } from '@mui/x-date-pickers/MonthCalendar';
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import {PickersDay, PickersDayProps}  from '@mui/x-date-pickers/PickersDay';
import {Dayjs} from 'dayjs';
import dayjs from 'dayjs';


export const DateFilterComponent: React.FC<{
  filter: FilterModel,
  onChange: (value: Date, filter: FilterModel) => void,
}> = ( {
  filter,
  onChange
}) => {

  const initValue = () => {
    if(filter.value.data) return new Date(filter.value.data)
    return new Date()
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(initValue());
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (newCalendarValue: any) => {
    const value = new Date(newCalendarValue);
    onChange(value, filter);
  }

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
    const value = new Date(selectedDate);
    onChange(value, filter);
  }

  const changeDate = (date: Date) => {
    setSelectedDate(date);
  }


  return (
      <>
        <Box ref={anchorRef}>
          <DateField
             disabled={true}
             variant="filled"
             fullWidth
             label={filter.label}
             value={dayjs(filter.value.data)}
             format="DD.MM.YYYY"
             onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
             InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            >
          </DateField>
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>

              <DateCalendar
                disabled={false}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
                shouldDisableDate={(date)=> {const day=date.day();
                                             return day===0 || day===6}}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );



};


/*************************************/
/*************************************/
/*************************************/

interface WeekPickerDayProps extends PickersDayProps<Dayjs>{
  selectedWeek: Dayjs | null;
}

function WeekPickerDay({
  day,
  selectedWeek,
  ...other
}: WeekPickerDayProps) {
  const weekStart = selectedWeek?.startOf('week');
  const weekEnd = selectedWeek?.endOf('week');

  const isSelected=
          !!selectedWeek &&
          !day.isBefore(weekStart, 'day') &&
          !day.isAfter(weekEnd, 'day');

  const isFirst = day.isSame(weekStart,'day')
  const isLast = day.isSame(weekEnd, 'day')
  return (
    <Box
      sx={(theme) => ({
        ...(isSelected && {
          backgroundColor: theme.palette.primary.light
        }),
        ...(isFirst && {
          borderTopLeftRadius: 999,
          borderBottomLeftRadius: 999
        }),
        ...(isLast && {
          borderTopRightRadius: 999,
          borderBottomRightRadius: 999
        })
      })}
    >
      <PickersDay
         {...other}
         day={day}
         selected={false}
      />
    </Box>
  )
}

const WeekPickerDayComponent =
        (selectedWeek: Dayjs | null) =>
        (props: PickersDayProps<Dayjs>) => (
          <WeekPickerDay
            {...props}
            selectedWeek={selectedWeek}
          />
        )




export const WeekFilterComponent: React.FC<{
  filter: FilterModel,
  onChange: (value: Date, filter: FilterModel) => void,
}> = ( {
  filter,
  onChange
}) => {

  const initValue = () => {
    if(filter.value.data) return new Date(filter.value.data)
    return new Date()
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(initValue());
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (newCalendarValue: any) => {
    const value = new Date(newCalendarValue);
    onChange(value, filter);
  }

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
    const value = new Date(selectedDate);
    onChange(value, filter);
  }

  const changeDate = (date: Date) => {
    setSelectedDate(date);
  }

  const displayValue = () => {
    const selectedWeek = dayjs(filter.value.data)
    const startOfWeek = selectedWeek.startOf('week')
    const endOfWeek = selectedWeek.endOf('week')
    return `${startOfWeek.format("DD.MM.YYYY")} - ${endOfWeek.format("DD.MM.YYYY")}`
  }


  return (
      <>
        <Box ref={anchorRef}>
          <TextField
             disabled={true}
             variant="filled"
             fullWidth
             label={filter.label}
             value={displayValue()}
             onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
             InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            >
          </TextField>
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>

              <DateCalendar
                disabled={false}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
                slots={{
                  day: WeekPickerDayComponent(dayjs(selectedDate))
                }}
                shouldDisableDate={(date)=> {const day=date.day();
                                             return day===0 || day===6}}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );
};


/*************************************/
/*************************************/
/*************************************/

export const MonthFilterComponent: React.FC<{
  filter: FilterModel,
  onChange: (value: Date, filter: FilterModel) => void,
}> = ( {
  filter,
  onChange
}) => {

  const initValue = () => {
    if(filter.value.data) return new Date(filter.value.data)
    return new Date()
  }

  const [error, setError] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>(initValue());
  const anchorRef = useRef<HTMLDivElement | null>(null);

  const handleChange = (newCalendarValue: any) => {
    const value = new Date(newCalendarValue);
    onChange(value, filter);
  }

  const openCalendar = (event: React.MouseEvent<HTMLElement>) => {
    setOpen(true);
  }

  const closeCalendar = () => {
    setOpen(false);
    const value = new Date(selectedDate);
    onChange(value, filter);
  }

  const changeDate = (date: Date) => {
    setSelectedDate(date);
  }


  return (
      <>
        <Box ref={anchorRef}>
          <DateField
             disabled={true}
             variant="filled"
             fullWidth
             label={filter.label}
             value={dayjs(filter.value.data)}
             format="MMMM YYYY"
             onChange={(newCalendarValue: any) => handleChange(newCalendarValue)}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={(event) => openCalendar(event)}>
                    <ScheduleIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            >
          </DateField>
          </Box>

          <Popover
            open={open}
            anchorEl={anchorRef.current}
            onClose={closeCalendar}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
          >
            <Box>
              <DateCalendar
                views={['year','month']}
                openTo='month'
                disabled={false}
                value={dayjs(selectedDate)}
                onChange={(newCalendarValue: any) => changeDate(newCalendarValue)}
              />
            </Box>
            <Box
               sx={{display: "flex",
                    justifyContent: "flex-end"}}
            >
              <Button
                 size="small"
                 onClick={() => closeCalendar()}
                 variant='contained'
              >
                  <CheckIcon />
              </Button>
            </Box>
          </Popover>
      </>
    );



};
